import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_pay_wrkrs_premium_pay_as_legally_required'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_pay_wrkrs_premium_pay_as_legally_required',
  name: 'Is the facility failing to pay workers premium pay as legally required based on: \r\r\n• worker’s competence (e.g. experience, skills, training) and/or\r\r\n• the nature of the work (e.g. hazard pay)?',
  description:
    'Answer No if the facility is providing premium pay to all applicable workers as legally required.\r\r\n\r\r\nThe intent of this question is to understand if premium pay based on competence or the nature of work is paid in line with applicable legal requirements.\r\r\n\r\r\n"Premium pay" refers to a premium amount or rate paid to workers in addition to their base wage/ rate. \r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-93',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7560,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
